module.exports = __webpack_public_path__ + "static/05_Robert-Princenthal-Circle-ebdce8221e10571ba03646458a0fe665.png";